import { createAsyncThunk } from '@reduxjs/toolkit'
import { SippApi } from '../../../services/SippExpress'
import { AxiosResponse } from 'axios'
import { WaterTestStripRequestDocument } from '../../../types/WaterTestStripRequestDocument'


interface RequestOptions {
  email: string,
  options?: any
}

export const fetchWaterTestKitResultsByUserAsync = createAsyncThunk<
any,
RequestOptions
>(
  'watertestkitresults/fetchByUser',
  async ({email, options}, { rejectWithValue }) => {
    try {
      const response = await SippApi.fetch.waterTestKitResultByUserIdOrEmail(email, options) as AxiosResponse<Partial<WaterTestStripRequestDocument>[]>
      return response.data
    } catch (error) {
      return rejectWithValue(error)
    }
  },
)


export const fetchWaterTestKitResultsByUserAsyncBuilder = (builder: any) => {
  builder.addCase(fetchWaterTestKitResultsByUserAsync.pending, (state, ) => {
    state.loading = true;
    state.error = null;

  })
  builder.addCase(fetchWaterTestKitResultsByUserAsync.fulfilled, (state, action, ) => {
    state.loading = false;
    state.data = action.payload;

  })
  builder.addCase(fetchWaterTestKitResultsByUserAsync.rejected, (state, action) => {
    state.loading = false;
    state.error = action.payload.message ;
  })
}